import { render } from "./OfficerCard.vue?vue&type=template&id=e10e061e"
import script from "./OfficerCard.vue?vue&type=script&lang=js"
export * from "./OfficerCard.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__